import {
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CreateIcon from '@material-ui/icons/Create';
import SearchIcon from '@material-ui/icons/Search';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LOCATIONS_CREATE,
  LOCATIONS_EDIT,
  LOCATIONS_VIEW,
} from '../../../../constants/LocationConst';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import ListFilterMenu from '../../../../shared/list-filter-menu/List-Filter-Menu';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import {
  allLocationsSelector,
  fetchAllLocations,
  setAllLocations,
} from '../../../property/propertySlice';
import './Location-List.scss';
import { notificationManager } from '../../../../utils/NotificationUtils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_LOCATION,
} from '../../../../constants/RoleConsts';
import { createDataSortMapping, deleteLocationDetail } from '../../../../utils/PropertyAPIUtils';
import WarningPopup from '../../../../shared/warning-popup/Warning-Popup';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../shared/custom-dragdrop/dragDrop';
import { SaveButton } from '../../../../shared/custom-dragdrop/Save-Button';
import useOutsideAlerter from '../../../../custom-hooks/useOutsideAlerter';
import { bouquetSelector, fetchAllBouquets } from '../../../cms/cmsSlice';
import { decryptLocalStorage } from '../../../../utils/authUtils';

const LocationList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [locations, setLocations] = useState([]);
  const [initialLocations, setInitialLocations] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    type: '',
  });
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const [filterMenu, setFilterMenu] = useState([]);
  const originalLocations = useSelector(allLocationsSelector);
  const bouquetList = useSelector(bouquetSelector);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tempSearchText, setTempSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const isFilterApplied = useRef(false);
  const dragDisabled =
    tempSearchText?.trim() !== '' || isFilterApplied?.current || locations?.length <= 1;

  useEffect(() => {
    if (originalLocations?.length || originalLocations?.length === 0) {
      setInitialLocations(originalLocations);
      setFilteredBaseList(originalLocations);
      setTempSearchText('');
      setSearchButton(true);
    }
  }, [originalLocations]);

  useEffect(() => {
    setLocations(initialLocations);
    setLoading(false);
  }, [initialLocations]);
  const resetFilterDataList = () => {
    const updatedFilterMenu = [];
    updatedFilterMenu.push(
      {
        title: 'All',
        field: 'all',
        subMenu: [],
      },
      {
        title: 'Location Type',
        field: 'type',
        subMenu: [
          { id: 'EXTERNAL', name: 'External', selected: false },
          { id: 'INTERNAL', name: 'Internal', selected: false },
        ],
      },
    );
    setFilterMenu(updatedFilterMenu);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      type: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      location: null,
    });
  };

  const handleCellMenuClick = (event, location) => {
    event.stopPropagation();
    setSelectedValue({
      id: location.id,
      name: location.name,
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
      location: location,
      warn: false,
    });
  };

  const deleteLocation = async (e, name) => {
    e.preventDefault();
    const selectedLocation = bouquetList?.map((item) => item.location);
    const uniqueRoomNo = [...new Set(selectedLocation)];
    if (uniqueRoomNo.toString().includes(name)) {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Unable to delete ',
        description:
          'The selected location cannot be deleted as it has been configured under one or more TV Channels-Bouquet',
        status: true,
        anchorEl: null,
        warn: true,
        buttonName: 'Back',
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed.',
        status: true,
        anchorEl: null,
        warn: false,
      }));
    }
  };

  const onDeleteLocation = async (e) => {
    resetFilterDataList();
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteLocationDetail(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllLocations(selectedHotel));
        dispatch(fetchAllBouquets(selectedHotel));
        notificationManager('success', 'Location deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Location');
      }
      handleClose();
    }
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      warn: false,
    });
  };

  const onViewDetails = (pack, e) => {
    if (e.target.className === 'MuiTableCell-root MuiTableCell-body') {
      onViewToggle(LOCATIONS_VIEW, true, pack);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.location) {
      onViewToggle(LOCATIONS_VIEW, true, selectedValue.location);
    }
  };

  const handleFilterMenu = (event) => {
    setFilterTargetButton(event.currentTarget);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  useEffect(() => {
    resetFilterDataList();
    setLocations(initialLocations);
    setLoading(false);
  }, [initialLocations]);

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    const filteredRows = filteredBaseList.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    setLocations(filteredRows);
  };

  useEffect(() => {
    resetFilterDataList();
  }, []);

  useEffect(() => {
    const totalItems = locations?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [locations?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleFilter = (filterItems, field) => {
    const updatedMenu = filterMenu?.map((m) =>
      m?.field === field ? { ...m, subMenu: filterItems } : m,
    );
    setFilterMenu(updatedMenu);
    const nothingSelected = field !== 'all' && filterItems?.every((item) => !item?.selected);
    if (field === 'all' || nothingSelected) {
      setFilteredBaseList(initialLocations);
      setLocations(initialLocations);
      resetFilterDataList();
      isFilterApplied.current = false;
      onsetPage(0);
      return;
    }
    isFilterApplied.current = true;
    onsetPage(0);
    const selectedTypes = filterItems?.filter((i) => i?.selected)?.map((i) => i?.id);
    setFilteredBaseList(initialLocations?.filter((loc) => selectedTypes?.includes(loc?.type)));
    setLocations(initialLocations?.filter((loc) => selectedTypes?.includes(loc?.type)));
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.location);
    handleClose();
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && !selectedValue.warn && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteLocation}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue.id && selectedValue.status === true && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}
      <div className='row mx-2 d-flex'>
        <div className='col-12 col-lg-4'>
          <TextField
            className='w-100'
            onChange={(e) => {
              setSearchText(e.target.value);
              setSearchButton(e?.target?.value ? false : true);
            }}
            label='Search'
            value={tempSearchText}
            InputProps={
              searchButton && {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton className='showpopup'>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }
          />
        </div>

        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end gap-2'>
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={locations}
            setPlaceHolder={setLocations}
            globalPlaceHolder={originalLocations}
            setGlobalPlaceHolder={setAllLocations}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Locations'
            module='LOCATION'
          />

          {locations && (
            <>
              <Button
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={
                  filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                    ? 'filterButton'
                    : 'showpopup'
                }
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterMenu}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
                hideSearch={true}
              />
            </>
          )}
          {permissions[RBAC_TYPE_HOTEL_LOCATION] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, LOCATIONS_CREATE);
              }}
              className='showpopup'
            >
              Add Location
            </Button>
          )}
        </div>
      </div>

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          locations && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell className='w-40'>Location</TableCell>
                    <TableCell className='w-50'>Location Type</TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      locations,
                      setLocations,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? locations?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : locations
                        ).map((item, i) => (
                          <Draggable
                            key={item?.id}
                            draggableId={item?.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(prov) => (
                              <TableRow
                                ref={prov?.innerRef}
                                {...prov?.draggableProps}
                                {...prov?.dragHandleProps}
                                className='border-white pointer'
                                onClick={(e) => onViewDetails(item, e)}
                              >
                                <TableCell>
                                  {!dragDisabled && (
                                    <DragIndicator className='res-menu-accordion-drag' />
                                  )}
                                </TableCell>
                                <TableCell className='w-40'>{item?.name}</TableCell>
                                <TableCell className='w-50'>
                                  {item?.type === 'INTERNAL' ? 'Internal' : 'External'}
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_LOCATION] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => handleCellMenuClick(e, item)}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => onOpenDrawer(e, LOCATIONS_EDIT)}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem className='pe-4' onClick={(e) => onClickView(e)}>
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => deleteLocation(e, item.name)}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>

                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={locations.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};
export default LocationList;
